import React, { useState, useEffect } from 'react';
import { List, Input, message, Modal, Form, Button, Switch } from 'antd';
import axios from 'axios';
import './Organizations.css';
import AppMenu from '../components/AppMenu';
import { useNavigate } from 'react-router-dom';

const { Search } = Input;

const Organizations = () => {
  const [organizations, setOrganizations] = useState([]);
  const [filteredOrganizations, setFilteredOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOrgModalOpen, setIsOrgModalOpen] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const fetchOrganizations = async (searchQuery = '') => {
    try {
      setLoading(true);
      const url = searchQuery 
        ? `${process.env.REACT_APP_API}/api/organizations?search=${encodeURIComponent(searchQuery)}`
        : `${process.env.REACT_APP_API}/api/organizations`;
      
      const response = await axios.get(url);
      setOrganizations(response.data);
      setFilteredOrganizations(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching organizations:', error);
      message.error('Failed to load organizations');
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    fetchOrganizations(value);
  };

  const openOrgView = (org) => {
    if (org) {
      window.open(`/organization/${org.id}`, '_blank');
    }
  };

  const openAddOrgModal = () => {
    form.resetFields();
    setIsOrgModalOpen(true);
  };

  const handleAddOrganization = async (values) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API}/api/organizations`,
        { 
          name: values.name,
          isInternal: values.isInternal !== undefined ? values.isInternal : true
        }
      );
      message.success('Organization added successfully');
      setIsOrgModalOpen(false);
      fetchOrganizations();
    } catch (error) {
      console.error('Error adding organization:', error);
      message.error('Failed to add organization');
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      <AppMenu />
      <div className="organization-page">
        <h1 style={{color:"white"}}>Organizations</h1>
        <div className="custom-search-bar">
          <Search
            placeholder="Search organizations (by name, ID, or orgSecret)"
            onSearch={handleSearch}
            onChange={(e) => {
              if (e.target.value === '') {
                fetchOrganizations('');
              }
            }}
            enterButton
            className="custom-search-input"
            allowClear
          />
          <Button className="add-organization-button" onClick={openAddOrgModal}>
            Add Organization
          </Button>
        </div>

        <List
          loading={loading}
          itemLayout="horizontal"
          dataSource={filteredOrganizations}
          renderItem={(org) => (
            <List.Item
              className="organization-list-item"
              onClick={() => openOrgView(org)}
            >
              <List.Item.Meta
              style={{padding:"2px 5px"}}
                title={<span className="organization-name">{org.name}</span>}
                description={
                  <span className="organization-address">
                    {org.address ? org.address : 'No address available'}
                  </span>
                }
              />
            </List.Item>
          )}
        />

        {/* Add Organization Modal */}
        <Modal
          title="Add New Organization"
          visible={isOrgModalOpen}
          onCancel={() => setIsOrgModalOpen(false)}
          footer={null}
          className="custom-modal"
        >
          <Form form={form} layout="vertical" onFinish={handleAddOrganization}>
            <Form.Item
              label="Organization Name"
              name="name"
              rules={[{ required: true, message: 'Please enter the organization name' }]}
            >
              <Input placeholder="Enter organization name" />
            </Form.Item>
            <Form.Item
              label="Internal Organization"
              name="isInternal"
              valuePropName="checked"
              initialValue={true}
            >
              <Switch 
                checkedChildren="Internal" 
                unCheckedChildren="External" 
                defaultChecked={true}
              />
            </Form.Item>
            <div style={{ textAlign: 'right' }}>
              <Button onClick={() => setIsOrgModalOpen(false)} style={{ marginRight: '10px' }}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </div>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default Organizations;
